import { render } from "./CreateUserForm.vue?vue&type=template&id=d165f316"
import script from "./CreateUserForm.vue?vue&type=script&lang=js"
export * from "./CreateUserForm.vue?vue&type=script&lang=js"
script.render = render

export default script